// extracted by mini-css-extract-plugin
export default {"container":"AgentInfoBlock_container__kplq8"};